<template>
  <div v-if="items.length">
    <div class="lead-timeline-info">
      <div class="timeline-avtor">
        <div class="lead-timeline-action timeline-comment">Commented</div>
        <div class="lead-timeline-employee">by {{ item.user_name }}:</div>
      </div>
      <div class="timline-date">{{ item['date&time'] }}</div>
    </div>
    <div class="timeline__item_text" v-for="comment in items" v-html="comment.content"></div>
  </div>
</template>

<script>
export default {
  name: "CommentType",
  props: {
    items: Array
  },
  data() {
    return {
      item: this.items[0] ?? {}
    }
  }
}
</script>

<style scoped>

</style>
